import * as React from "react";
import { SVGProps, memo } from "react";
const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      style={{
        fill: "#666766",
      }}
      d="M7 6h1v5H7zM7 4h1v1H7z"
    />
    <path
      style={{
        fill: "#666766",
      }}
      d="M7.5 1C3.9 1 1 3.9 1 7.5S3.9 14 7.5 14 14 11.1 14 7.5 11.1 1 7.5 1zm0 12C4.5 13 2 10.5 2 7.5S4.5 2 7.5 2 13 4.5 13 7.5 10.5 13 7.5 13z"
    />
  </svg>
);
const Memo = memo(SvgInfo);
export default Memo;
